/**
 * An enum defining the different entities.
 */
export enum EntityType {
    Person = "Person",
    Reminder = "Reminder",
    Group = "Group",
    Note = "Note",
    DefaultEdge = "DefaultEdge"
}
